import { CSSInterpolation } from '@emotion/css/create-instance'

// Note(@auster.chen): see https://robinhood.atlassian.net/browse/DS-2134
export const SCREENREADER_ONLY_STYLES: CSSInterpolation = {
  border: 0,
  // Deprecated but still used by most browsers, clip-path will be taking its place soon.
  clip: 'rect(1px, 1px, 1px, 1px)',
  clipPath: 'polygon(0px 0px, 0px 0px, 0px 0px, 0px 0px)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px',
}

// The minimum width of the text-entry area of an input. The minimum visual width is this
// value plus padding, border, and any other controls or visual treatment the input has.
export const INPUT_MIN_USABLE_WIDTH = 13
// The maximum width of the whole visual element that forms an input. The maximum width of
// the text-entry area is this value minus padding, border, and any other controls or visual
// treatment the input has.
export const INPUT_MAX_VISUAL_WIDTH = 640
